module.exports = __webpack_public_path__ + "8b6bc773ab0485b9a6cda0131ce3d1b6.png";